
import { Options } from "vue-class-component";

import {
  Field,
  CellGroup,
  DatetimePicker,
  Popup,
  Picker,
  Toast,
  CountDown,
} from "vant";
import BasePage from "@/common/BasePage"; // @ is an alias to /src
import UserVo from "@/vo/UserVo";
import AppUtil from "@/util/AppUtil";

@Options({
  components: {
    [CountDown.name]: CountDown,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
  },
})
/**完善用户资料 */
export default class PerfectInfo extends BasePage {
  _title = "完善资料";
  user = UserVo.getInstance();

  data: any = { smsCode: "", memberPhone: "" };
  /**输入的必填提示 */
  errArr: any = {
    memberName: "请输入真实姓名",
    sex: "性别必填",
    birthday: "请选择真实的出生日期",
    memberPhone: "请输入您的联系电话",
    smsCode: "验证码必填",
  };
  config = {
    showSex: false,
    showDate: false,
    minDate: new Date('1950/01/01'),
    maxDate: new Date(),
    sexArr: ["男", "女"],
    /**是否可以发送验证码 */
    canSend: true,
    /**倒计时时间60秒 */
    time: 60000,
  };
  mounted() {
    // if (!this.user.id) {
    //   this.user.req_data();
    // }
    this.data.memberName = this.user.memberName;
    this.data.sex = this.user.sexName;
    this.data.birthday = this.user.birthday;
    this.data.memberPhone = this.user.memberPhone;
  }
  check_phone() {

    if(!AppUtil.check_phone(this.data.memberPhone)){
      return Toast("请输入正确的中国手机号")
    }
  }
  submit_click() {
    //
    let data = this.data;
    for (let key in data) {
      if (!data[key]) {
        // console.log("key",key);
        // console.log("errArr",this.errArr[key]);
        return Toast(this.errArr[key]);
      }
    }
    if(!AppUtil.check_phone(this.data.memberPhone)){
      return Toast("请输入正确的中国手机号")
    }
    AppUtil.request(
      {
        url: "/zhMember/member/perfectMemberInfo",
        method: "post",
        data,
      },
      (res: any) => {
        console.log(res);
        Toast("修改成功，即将返回个人中心");
        setTimeout(() => {
          this.$router.push({ name: "User" });
        }, 2000);
      },
      "加密提交中..."
    );
  }
  submit_date(date: Date) {
    // console.log("选中的日期",e);
    this.config.showDate = false;
    this.data.birthday =
      date.getFullYear() +
      "-" +
      (date.getMonth() * 1 + 1) +
      "-" +
      date.getDate();
  }
  submit_sex(sex: string) {
    console.log("选择性别", sex);
    this.config.showSex = false;
    this.data.sex = sex;
  }
  req_code() {
    console.log("请求验证码");
    this.config.canSend = false;
    AppUtil.request(
      {
        url: "/zhMember/member/sendMessageCode",
        method: "post",
        data: {
          phone: this.data.memberPhone,
        },
      },
      (res: any) => {
        console.log(res);
      }
    );
  }
}
